import React, { useEffect, useState } from "react";
import {
    TextField,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    useTheme,
    IconButton,
} from "@mui/material";
import { getSingleVoucherDetails } from "state/apis";
import { toast } from "react-toastify";
import { Close as CloseIcon } from "@mui/icons-material";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import moment from "moment";
import { numberToWords } from "utils/constants";

const VoucherDetails = ({ open, onClose, onSubmit, editData, editMode }) => {
    const theme = useTheme();
    const [isLoading, setIsLoading] = React.useState(true);
    const [data, setData] = React.useState({});

    useEffect(() => {
        if (editData?.id) {
            fetchData();
        }
    }, [editData, editMode]);

    const fetchData = async () => {
        try {
            const res = await getSingleVoucherDetails(editData.id);
            setData(res?.voucher);
            setIsLoading(false);
        } catch (error) {
            console.error("Error fetching data:", error);
            toast.error("Failed to fetch data. Please try again.");
        }
    };

    const reportRef = React.useRef();

    const handlePrint = () => {
        const input = reportRef.current;

        html2canvas(input, { scale: 2 }).then((canvas) => {
            const imgData = canvas.toDataURL("image/png");
            const pdf = new jsPDF("p", "mm", "a4");

            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();

            const margin = 10; // Add margin (padding)

            const imgProps = pdf.getImageProperties(imgData);
            const imgHeight = (imgProps.height * (pdfWidth - 2 * margin)) / imgProps.width;

            let heightLeft = imgHeight;
            let position = margin;

            pdf.addImage(imgData, "PNG", margin, position, pdfWidth - 2 * margin, imgHeight);
            heightLeft -= pdfHeight - 2 * margin;

            while (heightLeft > 0) {
                position = heightLeft - imgHeight + margin;
                pdf.addPage();
                pdf.addImage(imgData, "PNG", margin, position, pdfWidth - 2 * margin, imgHeight);
                heightLeft -= pdfHeight - 2 * margin;
            }

            pdf.save(`voucher_receipts.pdf`);
        });
    };
    return (
        <Dialog open={open} onClose={onClose} className="report-container">
            <DialogContent style={{ width: "600px", padding: "20px" }}>
                <div ref={reportRef}>
                    {/* Voucher Header */}
                    <div
                        // className="d-flex justify-content-between align-items-center"
                        style={{
                            whiteSpace: "nowrap",
                            display: "flex",
                            justifyContent: "space-between",
                            // alignItems: "start",
                        }}
                    >
                        {/* Left Section */}
                        <div style={{ textAlign: "start", marginTop: "4px" }}>
                            <p style={{ margin: "0" }}>P.O. Box: 6390,</p>
                            <p style={{ margin: "0" }}>Sharjah - U.A.E</p>
                            <p style={{ margin: "0" }}>Tel: 06-5222877</p>
                        </div>

                        {/* Center Section */}
                        <div style={{ textAlign: "center", marginBottom: "10px" }}>
                            <h2 style={{ margin: "0" }}>{data?.property?.owner?.arabicName}</h2>
                            <h4 style={{ margin: "0" }}>{data?.property?.owner?.name}</h4>
                            <h3 style={{ margin: "0" }}>سند قبض</h3>
                            <h4 style={{ margin: "0", textDecoration: "underline" }}>
                                Receipt Voucher
                            </h4>
                        </div>

                        {/* Right Section */}
                        <div style={{ textAlign: "end", marginTop: "4px" }}>
                            <p style={{ margin: "0" }}>ص.ب : 6390</p>
                            <p style={{ margin: "0" }}>الشارقة – ا.ع.م</p>
                            <p style={{ margin: "0" }}>تليفون:-٠٦٥٢٢٢٨٧٧</p>
                        </div>
                    </div>

                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginBottom: "10px",
                            alignItems: "center",
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                alignItems: "start",
                                flexDirection: "column",
                            }}
                        >
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <p style={{ marginRight: "10px", margin: "0px" }}>
                                    {data?.property?.propertyName}-{" "}
                                    {data?.contract?.unit?.unitNumber}
                                </p>
                            </div>
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <p style={{ marginRight: "10px" }}>Dhs</p>
                                <span style={{ border: "1px solid black", padding: "0 20px" }}>
                                    {data?.totalAmount}
                                </span>
                            </div>
                        </div>

                        <div
                            style={{
                                display: "flex",
                                alignItems: "start",
                                flexDirection: "column",
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    width: "100%",
                                }}
                            >
                                <span>Receipt No:</span>
                                <span style={{ textAlign: "end", color: "red" }}>
                                    {data?.voucherNumber}
                                </span>
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    width: "100%",
                                }}
                            >
                                <span>Date:</span>
                                <span>
                                    <span
                                        style={{
                                            borderBottom: "1px dotted black",
                                        }}
                                    >
                                        {" "}
                                        {data?.date
                                            ? moment(data?.date).format("DD-MM-YYYY")
                                            : ""}{" "}
                                    </span>
                                    : التاريخ
                                </span>
                            </div>
                        </div>
                    </div>

                    {/* Received From and Amount */}
                    <div style={{ marginBottom: "20px" }}>
                        <p>
                            Received From Mr./Ms:{" "}
                            <span
                                style={{
                                    display: "inline-block",
                                    borderBottom: "1px dotted black",
                                    width: "53%",
                                }}
                            >
                                {data?.tenant?.name}
                            </span>
                            <span style={{ textAlign: "end" }}>استلمنا من السيد/السادة</span>
                        </p>
                        <p>
                            Amount in words:{" "}
                            <span
                                style={{
                                    display: "inline-block",
                                    borderBottom: "1px dotted black",
                                    width: "67%",
                                    minWidth: "250px",
                                }}
                            >
                                {numberToWords(parseInt(data?.totalAmount)) + " Only"}
                            </span>
                            <span style={{ textAlign: "end" }}>مبلغ وقدة فقط</span>
                        </p>
                    </div>

                    {/* Table for Cheques */}
                    <table
                        style={{ width: "100%", borderCollapse: "collapse", marginBottom: "10px" }}
                    >
                        <thead>
                            <tr>
                                <th style={{ border: "1px solid black", padding: "5px" }}>
                                    Cheque no/Cash
                                </th>
                                <th style={{ border: "1px solid black", padding: "5px" }}>Date</th>
                                <th style={{ border: "1px solid black", padding: "5px" }}>
                                    Particulars
                                </th>
                                <th style={{ border: "1px solid black", padding: "5px" }}>
                                    Amount
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {data?.voucherReceipt?.map((cheque, index) => (
                                <tr key={index}>
                                    <td style={{ padding: "5px" }}>{cheque?.note}</td>
                                    <td style={{ padding: "5px" }}>
                                        {cheque?.date
                                            ? moment(cheque?.date).format("DD-MM-YYYY")
                                            : ""}
                                    </td>
                                    <td style={{ padding: "5px" }}>{cheque?.particulars}</td>
                                    <td
                                        style={{
                                            padding: "5px",
                                            textAlign: "center",
                                        }}
                                    >
                                        {`${cheque.amount}/-`}
                                    </td>
                                </tr>
                            )) || (
                                <>
                                    <tr>
                                        <td
                                            style={{
                                                padding: "5px",
                                                textAlign: "center",
                                            }}
                                            colSpan={4}
                                        >
                                            No Data Found..
                                        </td>
                                    </tr>
                                </>
                            )}
                            {/* <tr>
                                <td
                                    style={{
                                        padding: "5px",
                                        textAlign: "center",
                                    }}
                                    colSpan={3}
                                ></td>
                                <td
                                    style={{
                                        padding: "5px",
                                        textAlign: "center",
                                    }}
                                >{`${data?.totalAmount}/-`}</td>
                            </tr> */}
                        </tbody>
                    </table>

                    {/* Footer */}
                    <div>
                        <p>
                            Being:{" "}
                            <span
                                style={{
                                    display: "inline-block",
                                    borderBottom: "1px dotted black",
                                    width: "90%",
                                    minWidth: "250px",
                                }}
                            >
                                {data?.note}
                            </span>
                        </p>
                    </div>

                    {/* Signatures */}
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginTop: "20px",
                        }}
                    >
                        <div>Accountant: ___________________</div>
                        <div>Manager: ___________________</div>
                    </div>
                </div>
                <DialogActions>
                    <Button
                        variant="contained"
                        onClick={handlePrint}
                        sx={{
                            color: theme.palette.primary.light,
                            backgroundColor: theme.palette.secondary[200],
                        }}
                    >
                        Print
                    </Button>
                </DialogActions>
            </DialogContent>
        </Dialog>
    );
};

export default VoucherDetails;
